// tslint:disable
///<reference path="env-vars-module.ts"/>
module EnvironmentVariables {
    import AllEnvironmentNames = Shared.Environments.IAllEnvironmentNames;
    module.controller("EnvironmentVariablesController", [
        "$timeout",
        "$rootScope",
        "EnvironmentVariablesService",
        "DataTypeService",
        "notifications",
        "$stateParams",
        "$state",
        function ($timeout, $rootScope, dataService, dataTypeService, notifications, $stateParams, $state) {
            var self = this;
            self.loaded = false;
            self.getType = dataTypeService.getType;

            var environmentName = $stateParams.environmentName;

            dataService.getEnvironmentWithDisplayName().then(response => {
                self.environmentNames = response.data.data;
            });

            self.paginationLimit = 25;
            self.currentPage = 1;
            self.dataTypes = dataTypeService.dataTypes;
            dataService.getEnvironmentVariables().then(function (response) {
                if (response.data && response.data.success) {
                    self.version = response.data.data.version + 1;
                    self.json = JSON.parse(response.data.data.environmentVariables);

                    const enivronmentKeys = Object.keys(self.json);
                    enivronmentKeys.forEach(environmentKey => {
                        //keys of each environment
                        var rootKeys = Object.keys(self.json[environmentKey]);
                        //sort by ignoring lowercase
                        const sortedRootKeys = _.sortBy(rootKeys, key => key.toLowerCase());

                        //set the sorted objects back to the environment
                        self.json[environmentKey] = _.fromPairs(
                            _.map(sortedRootKeys, key => [key, self.json[environmentKey][key]])
                        )

                        //sort group variables in the same name and filter out all non objects and secret keys
                        rootKeys.forEach(rootKey => {
                            if (_.isPlainObject(self.json[environmentKey][rootKey]) && isNotFrendsSecretObject(self.json[environmentKey][rootKey])) {

                                var groupKeys = Object.keys(self.json[environmentKey][rootKey]);
                                const sortedGroupKeys = _.sortBy(groupKeys, key => key.toLowerCase());
                                //set the sorted object back to the root key
                                self.json[environmentKey][rootKey] = _.fromPairs(
                                    _.map(sortedGroupKeys, key => [key, self.json[environmentKey][rootKey][key]])
                                );
                            }
                        })
                    });

                    self.currentEnvironment = { name: environmentName };
                    self.deepCopyDefaultEnvironmentPropertiesAndCheckForMissingKeys();
                    self.originalJson = JSON.stringify(self.json);
                    self.variablesForEnvironment = getVariablesFromEnvironmentJson(self.json[environmentName]);
                    self.visibleVariables = self.variablesForEnvironment;
                    self.filterBy = "key,value";
                    self.loaded = true;
                }
            });

            function isNotFrendsSecretObject(obj) {
                if (typeof obj !== 'object') {
                    return true;
                }
                return !("__frends_isSecret" in obj);
            }

            self.getEnvironmentName = function (sourceEnvName: string) {
                if (self.environmentNames && sourceEnvName) {
                    return self.environmentNames.find(x => x.name === sourceEnvName).displayName;
                }
            };

            self.openForms = 0;

            $rootScope.$on('newItemFormOpened', function (event, data) {
                self.openForms++;
            });

            $rootScope.$on('newItemFormClosed', function (event, data) {
                self.openForms--;
            });

            self.changeEnvironment = function (environmentName) {
                self.currentEnvironment.name = environmentName;
                $state.go('environment', { environmentName: environmentName }, { notify: false })
                self.openForms = 0; // reset open form count
                self.variablesForEnvironment = getVariablesFromEnvironmentJson(self.json[environmentName]);
                self.setFilter();
            }

            // the values from in the non-default environments can be null so we have to get
            // the data type from the default environment
            self.getTypeFromDefault = function (key, innerKey) {
                var valueInDefault = "";
                if (key && innerKey) {
                    valueInDefault = self.json['Default'][key][innerKey];
                } else if (key) {
                    valueInDefault = self.json['Default'][key];
                }
                return dataTypeService.getType(valueInDefault);
            }

            self.isDefaultEnv = function () {
                return self.currentEnvironment.name === "Default";
            };

            function findVariable(key) {
                return _.find(self.variablesForEnvironment, function (variable: any) {
                    return variable.key === key;
                });
            }

            function updateKeyInCurrentVariablesForEnvironment(key, newKey) {
                var foundVariable: any = findVariable(key);
                foundVariable.key = newKey;
            }

            function containsSecret(parentKey: string, key: string): boolean {
                var objectToCheck = (parentKey != null && parentKey !== "") ? self.json['Default'][parentKey][key] : self.json['Default'][key];
                if (typeof objectToCheck !== 'object') {
                    // not an object -> cannot be or contains secrets
                    return false;
                }
                if (isNotFrendsSecretObject(objectToCheck)) {
                    return _.some(objectToCheck, obj => !isNotFrendsSecretObject(obj));
                } else {
                    return true;
                }
            }

            self.updateKey = function (key, newKey, input: ng.INgModelController, parentKey) {
                input.$setValidity("required", !!newKey)
                input.$setValidity("unique", isKeyUnique(newKey, key, parentKey));
                input.$setValidity("keyWord", !isRestrictedKeyword(newKey));
                input.$setValidity("pattern", keyMatchesValidPattern(newKey));
                input.$setValidity("containsSecret", key === newKey || !containsSecret(parentKey, key))

                if (input.$valid && newKey !== undefined && key !== newKey) {
                    _.each(self.json, function (env) {
                        var objectToUpdate = parentKey === null ? env : env[parentKey];

                        if (objectToUpdate[newKey] === undefined) {
                            objectToUpdate[newKey] = objectToUpdate[key];
                            delete objectToUpdate[key];
                        }
                    });

                    if (parentKey === null) {
                        // in this case we are updating a key for a root env. variable and we need to change that
                        // current key in the variables for the current environment, so the list and search is up to date
                        updateKeyInCurrentVariablesForEnvironment(key, newKey);
                    }
                }
            };

            function isKeyUnique(value: string, originalKey: string, parentKey: string) {
                if (!value) {
                    return true; // do not validate null or undefined, there are other validators for that
                }

                if (value.toLocaleLowerCase() === (originalKey && originalKey.toLocaleLowerCase())) {
                    return true;
                }

                var blacklist: string[] = parentKey === null
                    ? self.variablesForEnvironment.map(v => v.key)
                    : _.keys(self.variablesForEnvironment.find(v => v.key === parentKey).val);

                var valid = !_.some(blacklist, function (existingKey) {
                    return existingKey.toLocaleLowerCase() === value.toLocaleLowerCase();
                });

                return valid;
            }

            var reservervedWords = ["abstract", "as", "base", "bool", "break", "byte", "case",
                "catch", "char", "checked", "class", "const", "continue", "decimal", "default",
                "delegate", "do", "double", "else", "enum", "event", "explicit", "extern", "false",
                "finally", "fixed", "float", "for", "foreach", "goto", "if", "implicit", "in", "int",
                "interface", "internal", "is", "lock", "long", "namespace", "new", "null", "object",
                "operator", "out", "override", "params", "private", "protected", "public", "readonly",
                "ref", "return", "sbyte", "sealed", "short", "sizeof", "stackalloc", "static", "string",
                "struct", "switch", "this", "throw", "true", "try", "typeof", "uint", "ulong", "unchecked",
                "unsafe", "ushort", "using", "virtual", "void", "volatile", "while"];
            function isRestrictedKeyword(value: string) {
                if (!value) {
                    return false; // do not validate null or undefined, there are other validators for that
                }
                var valueMatchesKeyWord = _.some(reservervedWords, function (keyWord) { return value.toLowerCase() === keyWord.toLowerCase(); });
                return valueMatchesKeyWord;
            }

            var pattern = /^[a-zA-ZöäåüÖÄÅÜ][a-zA-Z0-9_öäåüÖÄÅÜ]*$/;
            function keyMatchesValidPattern(key) {
                return pattern.test(key);
            }

            self.updateVal = function (key, newVal, parentKey) { //Update val is model bound and so we do not have to update the variables array
                if (newVal !== undefined && newVal !== null) //Do not update on null values, IE passes invalid numeric values as null. This breaks the rendering of the input
                {
                    if (newVal.__frends_isSecret) {
                        newVal.isDirty = true;
                    }
                    var env = self.json[self.currentEnvironment.name];
                    if (parentKey === null) {
                        //Updating a literal property on a root level object
                        env[key] = newVal;
                    } else {
                        //Updating a literal property on a nested (inner) object
                        env[parentKey][key] = newVal;
                    }

                }
            };

            self.addItem = function (newItem, parentObject, parentKey) {
                var value = newItem.value;
                if (newItem.dataType.typeName == "Number" && value == null)//If no value is given for a number, default to 0
                {
                    value = 0;
                }
                var parentType = "Invalid";
                if (parentKey === undefined) {
                    // parentKey is undefined -> we're adding to the root (environment)
                    parentType = "Object";
                } else {
                    // get the parent type from the default environment with the parent key
                    parentType = self.getTypeFromDefault(parentKey);
                }

                if (parentType === "Array") {
                    if (parentObject === null) {
                        // an unitialized array in a non-default environment -> initialize it
                        parentObject = [];
                        var foundVariable: any = findVariable(parentKey);
                        foundVariable.val = [];
                        foundVariable.val.push(value);
                    }
                    parentObject.push(value);
                    self.json[self.currentEnvironment.name][parentKey] = parentObject;
                } else if (parentType === "Object") {
                    parentObject[newItem.key] = value;
                    self.deepCopyDefaultEnvironmentPropertiesAndCheckForMissingKeys();
                    if (parentKey === undefined) { // We are adding a new variable on the root level. This has to be added to the variables for environment. Then we are filtering to this variable.
                        self.variablesForEnvironment.push({ "key": newItem.key, "val": value, "search": JSON.stringify(value).toLowerCase() });
                        self.filterString = newItem.key;
                        self.setFilter();
                    }
                } else {
                    console.error("Parent must be an array or object to add item: " + JSON.stringify(newItem));
                }
            };
            self.removeItem = function (key, parentKey) {
                if (parentKey === null) {
                    // Removing an item on root object, which is never an array.
                    _.each(self.json, function (env) {
                        delete env[key];
                    });
                    _.remove(self.variablesForEnvironment, function (variable: any) {
                        return variable.key === key;
                    });
                    _.remove(self.visibleVariables, function (variable: any) {
                        return variable.key === key;
                    });
                } else {
                    // Removing a nested item.
                    var parent = self.json[self.currentEnvironment.name][parentKey];
                    if (self.getType(parent) === "Array") {
                        parent.splice(key, 1); // Removing items from an array only removes it for the current environment.
                    } else {
                        _.each(self.json, function (env) {
                            delete env[parentKey][key]; // removing items from a sub-object removes it for every environment
                        });
                    }
                }
            };

            self.copyObjectProperties = function (sourceObject, targetObject) {
                _.each(sourceObject, function (value, key) {
                    var typeName = self.getType(sourceObject[key]);
                    if (targetObject[key] === undefined) {
                        if (typeName === "Object") {
                            targetObject[key] = {}; // Only initialize objects, not their fields or other values
                        } else {
                            targetObject[key] = null;
                        }
                    }
                });
            };

            self.deepCopyDefaultEnvironmentPropertiesAndCheckForMissingKeys = function () {
                var defaultEnvProperties = self.json.Default;
                self.missingKeys = [];
                _.each(self.json, function (environmentValue, environmentName: any) {
                    if (environmentName !== "Default") {
                        self.copyObjectProperties(defaultEnvProperties, environmentValue);
                        _.each(environmentValue, function (propertyValue, propertyKey) {
                            //Check if of the non default environment properties exist in the default environment
                            self.checkMissingKey(defaultEnvProperties, propertyKey, environmentName);
                            if (self.getTypeFromDefault(propertyKey) === "Object") {
                                self.copyObjectProperties(defaultEnvProperties[propertyKey], propertyValue);
                                //Do the same default check for each root property that is of type object
                                _.each(propertyValue, function (value, key) {
                                    self.checkMissingKey(defaultEnvProperties, propertyKey + "." + key, environmentName);
                                });
                            }
                        });
                    }
                });
            };

            self.checkMissingKey = function (defaultEnvProperties, propertyKey, environmentName) {
                if (!_.has(defaultEnvProperties, propertyKey)) {
                    self.missingKeys.push({ environment: environmentName, key: propertyKey });
                }
            }
            self.totalItemsCount = 0;
            self.filterString = "";


            function getVariablesFromEnvironmentJson(data) {
                var result = [];
                _.each(data, function (val, key: any) {
                    result.push({ "key": key, "val": val, "search": JSON.stringify(val).toLowerCase() });
                });
                self.totalItemsCount = result.length;
                return result;
            };

            self.setFilter = function () {
                var lowerCaseFilter = self.filterString.toLowerCase();
                var filterByKey = self.filterBy.indexOf('key') >= 0;
                var filterByValue = self.filterBy.indexOf('value') >= 0;

                var filtered = _.filter(self.variablesForEnvironment, function (variable: any) {
                    if (filterByKey && variable.key.toLowerCase().indexOf(lowerCaseFilter) !== -1) {
                        return true;
                    }
                    if (filterByValue && variable.search.indexOf(lowerCaseFilter) !== -1) {
                        return true;
                    }
                });
                self.totalItemsCount = filtered.length;
                self.currentPage = 1;
                self.visibleVariables = filtered;
            };

            self.dirtyCheck = function () {
                return self.originalJson !== JSON.stringify(self.json);
            };

            self.saveRequestPending = false;
            self.save = function () {
                self.saveRequestPending = true;
                var jsonString = JSON.stringify(self.json);
                dataService.saveEnvironmentVariables(jsonString, self.version).then(function (response) {
                    self.saveRequestPending = false;
                    if (response.data && response.data.success) {
                        notifications.notify(response.data.data);
                        self.originalJson = jsonString;
                        self.version++;
                    }
                });
            };
        }
    ]);
}